
<template>
  <div @click="createPage()" data-ui="add-page"
       class="bg-trader-dark-gray  ml-2  min-w-[100px] cursor-pointer flex items-center justify-center hover:bg-trader-blue hover:text-white">
    <i class="fa-solid fa-file-circle-plus text-2xl"></i>
  </div>
</template>

<script>
import {gql} from "@apollo/client/core";
import apolloClient from "@/apolloClient";
import {eventBus} from "@/application/EventBus";
import SuccessConfirmation from "@/components/Dialogs/SuccessConfirmation.vue";
import SignalBus from "@/application/SignalBus";

export default {
  name: "CAddPage",
  props: {
    magazineId: {
      type: String,
      required: true,
    },
  },
  methods:{
    async createPage() {
      const pageData = {
        magazineId: this.magazineId,
      }
      const mutation = gql`
        mutation createPage($page: AdPageInput!) {
           createPage(page: $page) {
            success
          }
        }
      `;
      try {
        const variables = {
          page: pageData
        };
        const {data} = await apolloClient.mutate({mutation, variables});
        if (data.createPage.success) {
          eventBus.openModal(SuccessConfirmation);
          eventBus.setData({
            title: "Seite hinzugefügt",
            message: "Die Seite wurde hinzugefügt.",
          });
        }
       SignalBus.emit("reloadPages");
      } catch (error) {
        console.error("fehler beim Erstellen einer neuen seite ".error);
      }
    },
  }
}

</script>
